import { baseAPIUrl } from 'app/helpers';

export function oauthRedirectUrl(provider:string, state?:string) {
  const url = `${baseAPIUrl()}/auth/${provider}`

  return state ? `${url}?state=${encodeURIComponent(state)}` : url;
}
